<template>
  <d-card class="card-small">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0" v-if="invoiceList.length > 1">
      <!-- Top Referrals List Group -->
      <d-list-group flush class="list-group-small" >
        <d-list-group-item
          v-for="(invoice, idx) in invoiceList"
          :key="idx"
          class="d-flex px-3"
        >
          <span class="text-semibold text-fiord-blue">{{ invoice.Id }}</span>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{
            invoice.ServiceNames
          }}</span>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{
            invoice.Total
          }}</span>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{
            invoice.Status
          }}</span>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{
            invoice.Date
          }}</span>
          <span class="ml-auto text-right text-semibold text-reagent-gray"
           v-if="invoice.Status == 'Төлөгдсөн'"></span>
          <button
            v-if="invoice.Status == 'Төлөгдөөгүй'"
            class="ml-4 btn btn-outline-success btn-sm"
            @click="onClickPay(invoice.Id, invoice.Total)"
          >
            Төлөх
          </button>        
        </d-list-group-item>
      </d-list-group>
     
      <d-modal v-if="openModal">
        <d-modal-body>
          <step-form
            :callback="false"
            :btnString="'Нэхэмжлэх'"
            :qpStatus="qpayStatus"
            :invoiceCall="true"
            :invoiceId="invoiceId"
            :invoiceAmount="invoiceAmount"
            @clicked="onClickChild"
          />
        </d-modal-body>
        
        <d-modal-footer>
          <d-row>
            <d-col lg="6" md="6" sm="6" v-show="qpayBtn">
              <span>Та төлбөрөө төлсөн бол OK! товчийг дарна уу</span>
            </d-col>
            <d-col lg="3" md="3" sm="3" v-show="qpayBtn">
              <button
                type="link"
                class="btn btn-outline-success"
                @click="onClickQpay()"
              >
                OK
              </button>
            </d-col>
            <d-col lg="3" md="3" sm="3">
              <button
                type="link"
                class="btn btn-outline-info"
                @click="
                  (openModal = false),
                    (parentBoolean = false),
                    (qpayBtn = false),
                    (qpayStatus = '')
                "
              >
                Хаах
              </button>
            </d-col>
          </d-row>
        </d-modal-footer>
      </d-modal>
    </d-card-body>
     <d-card-body v-else>
          <div class="row">
            <div class="col">
              <h7 class="m-0">Нэхэмжлэх олдсонгүй </h7>
           </div>
          </div>
        </d-card-body>
  </d-card>
</template>

<script>
import axios from "axios";
import StepForm from "../form/StepFormValidation.vue";

export default {
  name: "invoiceList",
  components: {
    StepForm,
  },
  data() {
    return {
      qpayStatus: "",
      qpayBtn: false,
      openModal: false,
      invoiceAmount: 0,
      invoiceId: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "Нэхэмжлэхийн жагсаалт",
    },
  },
  methods: {
    onClickChild(value) {
      if (value != "") {
        this.qpayBtn = true;
        this.qpayTransactionId = value;
      }
      //value from child component
      else this.openModal = value;
    },
    onClickQpay() {
      const tranconfig = {
        method: "post",
        url:
          "https://www.mongolsat.mn/isat/contract/invoice/check?id=" +
          this.qpayTransactionId +
          "",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.userToken,
        },
      };
      //transaction check by id
      axios(tranconfig).then(
        (response) => {
          if (response.data.code == 0 && response.data.object == true) {
            this.qpayStatus = "success";
            var configData = {
              method: "post",
              url: "https://mongolsat.mn/isat/contract/data",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPayment = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/payments?page=1",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configPhone = {
              method: "post",
              url: "https://www.mongolsat.mn/isat/contract/phones",
              headers: {
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };
            var configInvoice = {
              method: "get",
              url: "https://mongolsat.mn/isat/contract/invoices?page=1&rows=10",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.userToken,
              },
            };

            const requestOne = axios(configData);
            const requestTwo = axios(configPayment);
            const requestThirth = axios(configPhone);
            const requestFourth = axios(configInvoice);

            axios
              .all([requestOne, requestTwo, requestThirth, requestFourth])
              .then(
                axios.spread((...responses) => {
                  const responseOne = responses[0];
                  const responseTwo = responses[1];
                  const responseThirth = responses[2];
                  const responseFourth = responses[3];

                  if (
                    responseOne.data.code == 0 &&
                    responseOne.data.object != null
                  ) {
                    this.$store.dispatch("retrieveAddData", {
                      addData: responseOne.data.object.topupQuota,
                    });
                    this.$store.dispatch("retrieveRemainData", {
                      remainData: responseOne.data.object.remainingQuota,
                    });
                  }
                  if (responseTwo.data != null && responseTwo.data.length > 0) {
                    this.$store.dispatch("retrievePayments", {
                      payments: responseTwo.data,
                    });
                  }
                  if (
                    responseThirth.data.code == 0 &&
                    responseThirth.data.object != null
                  ) {
                    var tmpPhoneList = [];
                    var i = 0;

                    for (i = 0; i < responseThirth.data.object.length; i++) {
                      var data = {};
                      (data.id = i),
                        (data.name = responseThirth.data.object[i].name),
                        (data.phone = responseThirth.data.object[i].phone),
                        (data.balance =
                          responseThirth.data.object[i].balance < 1
                            ? 0
                            : responseThirth.data.object[i].balance),
                        tmpPhoneList.push(data);
                    }
                    this.$store.dispatch("retrievePhoneData", {
                      phoneData: tmpPhoneList,
                    });

                    this.$store.dispatch("retrieveSelected", {
                      selected: tmpPhoneList[this.selectedOption.id],
                    });

                    this.$store.dispatch("retrieveBalance", {
                      balance:
                        responseThirth.data.object[this.selectedOption.id]
                          .balance < 1
                          ? 0
                          : responseThirth.data.object[this.selectedOption.id]
                              .balance,
                    });
                  }
                  if (
                    responseFourth.data.records != null &&
                    responseFourth.data.records.length > 0
                  ) {
                    this.invoiceList = responseFourth.data.records;
                    this.$store.dispatch("retrieveInvoice", {
                           invoice: responseFourth.data.records
                    });              
                  }
                }),
                (error) => {
                  console.log(error);
                }
              );
          } else this.qpayStatus = "fail";
          this.qpayBtn = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    onClickPay(id, amount) {
      this.invoiceId = id + "";
      this.invoiceAmount = amount;
      this.openModal = true;
    },
  },
  computed: {
    selectedOption() {
      return this.$store.getters.selected;
    },
    invoiceList() {
      return this.$store.getters.userInvoice;
    },
  },
};
</script>
